import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { getUserDisplayName } from "@helpers/user";
import type { OrganizationActivityPerson } from "../useOrganizationActivityPeople";

/** A member or client user row of Updated by. */
export interface PersonItem {
    id: number;
    name: string;
    user: OrganizationActivityPerson;
}

/** The person's name, else their email; none when they have neither. */
export const toPersonName = (user: OrganizationActivityPerson) =>
    getUserDisplayName(user) || undefined;

const toPersonDisplayName = (user: OrganizationActivityPerson) =>
    toPersonName(user) ?? `User #${user.id}`;

export const toPersonItem = (user: OrganizationActivityPerson): PersonItem => ({
    id: user.id,
    name: toPersonDisplayName(user),
    user,
});

export const toPersonAvatar = ({ user }: PersonItem) => (
    <UserAvatar user={user} size="xs" aria-hidden />
);

/** The rows whose name or email contains the lowercased search. */
export const toMatchingPickerItems = ({
    items,
    lowerSearch,
}: {
    items: readonly PersonItem[];
    lowerSearch: string;
}): Array<PickerItemData<string>> =>
    items
        .filter(
            (item) =>
                item.name.toLowerCase().includes(lowerSearch) ||
                (item.user.email?.toLowerCase().includes(lowerSearch) ?? false),
        )
        .map((item) => ({
            value: String(item.id),
            label: item.name,
            leading: toPersonAvatar(item),
        }));
